import * as React from "react";
import { TApiSet } from '../../../../../api/endpoints/Set';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

type OwnProps = {
  set: TApiSet;
  isAvailable: boolean;
  isSelected: boolean;
  onClick: () => void;
};

/**
 * A button representing a set.
 */
const Button = (props: OwnProps) => {
  const { isAvailable, set } = props;

  return (
    <button
      className={
        "products__select-button " +
        (props.isSelected ? "active " : "") +
        (isAvailable ? "" : "disabled")
      }
      onClick={props.onClick}
    >
      <span className="name">Set {set.name}: {set.description}</span>{" "}
      <FontAwesomeIcon icon={faChevronRight} className="arrow" />
    </button>
  );
};

export default Button;
